import { SEND_CONTACT_FORM, SET_HAS_ERROR, SET_IS_FETCHED } from './formActionTypes';
import { RequestMessagePayload } from '../../interfaces/professional/Professional';

export const setHasError = (hasError: boolean) => ({ type: SET_HAS_ERROR, hasError });
export const setIsFetched = (isFetched: boolean) => ({ type: SET_IS_FETCHED, isFetched });
export const sendFrom = (requestPayload: RequestMessagePayload, callback: () => void) => ({
  type: SEND_CONTACT_FORM,
  requestPayload,
  callback,
});
